import { Building2, CheckCircle2, FileSearch, XCircle } from "lucide-react";
import { Card, CardContent } from "@/shared/ui/card";

interface KpiCardsProps {
  totalInspections: number;
  approvalRate: string;
  rejectedCount: number;
  supplierCount: number;
}

export function KpiCards({
  totalInspections,
  approvalRate,
  rejectedCount,
  supplierCount,
}: KpiCardsProps) {
  return (
    <div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Total Inspections</p>
              <p className="text-2xl font-bold">{totalInspections}</p>
            </div>
            <FileSearch className="w-8 h-8 text-primary opacity-80" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Approval Rate</p>
              <p className="text-2xl font-bold text-success">{approvalRate}%</p>
            </div>
            <CheckCircle2 className="w-8 h-8 text-success opacity-80" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Rejected</p>
              <p className="text-2xl font-bold text-destructive">{rejectedCount}</p>
            </div>
            <XCircle className="w-8 h-8 text-destructive opacity-80" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Active Suppliers</p>
              <p className="text-2xl font-bold">{supplierCount}</p>
            </div>
            <Building2 className="w-8 h-8 text-primary opacity-80" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
